var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F59B00",
    fillRule: "evenodd",
    d: "M16 0c2.88 0 5.547.72 8 2.16A16.135 16.135 0 0 1 29.84 8c1.44 2.453 2.16 5.12 2.16 8s-.72 5.547-2.16 8A16.135 16.135 0 0 1 24 29.84C21.547 31.28 18.88 32 16 32s-5.547-.72-8-2.16A16.135 16.135 0 0 1 2.16 24C.72 21.547 0 18.88 0 16s.72-5.547 2.16-8A16.135 16.135 0 0 1 8 2.16C10.453.72 13.12 0 16 0zm5.552 8.084c-.175.097-.313.22-.413.366l-6.611 11.725-3.757-6.229a.669.669 0 0 0-.45-.366.752.752 0 0 0-.564.073.824.824 0 0 0-.375.44.69.69 0 0 0 .037.586l4.508 7.548c.15.293.375.44.676.44h.075c.15 0 .276-.05.376-.147.1-.098.175-.22.225-.366l7.363-13.118a.809.809 0 0 0-.076-.586.802.802 0 0 0-.45-.403.65.65 0 0 0-.564.037z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIcon);
export default __webpack_public_path__ + "static/media/check_icon.02164feea38a64a5233dd15a432d9d55.svg";
export { ForwardRef as ReactComponent };